var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#DC2626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2502 9.4V8.575C19.2502 7.725 18.5752 7.05 17.7252 7.05H12.1752L12.1002 6.85C11.9252 6.4 11.5002 6.125 11.0252 6.125H5.9752C5.1252 6.125 4.4502 6.8 4.4502 7.65V17.375C4.4502 18.225 5.1252 18.9 5.9752 18.9H18.0502C18.9002 18.9 19.5752 18.225 19.5752 17.375V10.175C19.5752 9.875 19.4502 9.6 19.2502 9.4ZM17.7252 8.15C17.9502 8.15 18.1252 8.325 18.1252 8.55V9.025H12.9752L12.6252 8.15H17.7252ZM18.4502 17.375C18.4502 17.6 18.2752 17.775 18.0502 17.775H5.9752C5.7502 17.775 5.5752 17.6 5.5752 17.375V7.625C5.5752 7.4 5.7502 7.225 5.9752 7.225L11.0502 7.25L12.0752 9.8C12.1502 10.025 12.3752 10.15 12.6002 10.15H18.4252C18.4252 10.15 18.4502 10.15 18.4502 10.175V17.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 13.4859H12.8V12.4109C12.8 12.1109 12.55 11.8359 12.225 11.8359C11.925 11.8359 11.65 12.0859 11.65 12.4109V13.4859H10.575C10.275 13.4859 10 13.7359 10 14.0609C10 14.3859 10.25 14.6359 10.575 14.6359H11.65V15.7109C11.65 16.0109 11.9 16.2859 12.225 16.2859C12.525 16.2859 12.8 16.0359 12.8 15.7109V14.6359H13.875C14.175 14.6359 14.45 14.3859 14.45 14.0609C14.45 13.7359 14.175 13.4859 13.875 13.4859Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.54639a0f52411bb52d16e2768ed0697a.svg";
export { ForwardRef as ReactComponent };